const zIndex = {
    name: "z-index",
    path: "/z-index",
    title: "z-index",
    description: "Utilities for controlling the stack order of an element.",
    value: {
        "z-index": {
          "z-<number>": "<number>",
          "z-auto": "auto",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="z-40 ...">05</div>
<div class="z-30 ...">04</div>
<div class="z-20 ...">03</div>
<div class="z-10 ...">02</div>
<div class="z-0 ...">01</div>
                `
            },
        },
        {
            "example": {
                "code": `<div class="z-40 ...">05</div>
<div class="z-30 ...">04</div>
<div class="z-0 ...">03</div>
<div class="z-10 ...">02</div>
<div class="z-0 ...">01</div>`
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">z-<number></code>
                  utilities like z-10 and z-50 to control the stack order (or three-dimensional positioning) of an element, regardless of the order it has been displayed:
            </p>

                <div class="flex justify-center -space-x-3 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="z-40 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">05</div>
                    <div class="z-30 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">04</div>
                    <div class="z-20 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">03</div>
                    <div class="z-10 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">02</div>
                    <div class="z-0 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">01</div>
                </div>

            
            `
        },
         {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">Using negative values</code>
                  To use a negative z-index value, prefix the class name with a dash to convert it to a negative value:
            </p>

            <div class="flex justify-center -space-x-3 font-mono text-sm leading-6 font-bold text-color-white">
                <div class="z-40 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">05</div>
                <div class="z-30 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">04</div>
                <div class="z-0 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">03</div>
                <div class="z-10 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">02</div>
                <div class="z-0 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">01</div>
            </div>
        
            `
        },
    ]
};

export default zIndex;

<div className="sr-only">

<div class="flex justify-center -space-x-3 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="z-40 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-1 outline-color-white dark:outline-color-[#11121E]">05</div>
                    <div class="z-30 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-2 outline-color-white dark:outline-color-[#11121E]">04</div>
                    <div class="z-20 -z-10 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-2 outline-color-white dark:outline-color-[#11121E]">03</div>
                    <div class="z-10 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-2 outline-color-white dark:outline-color-[#11121E]">02</div>
                    <div class="z-0 flex size-16 items-center justify-center rounded-full bg-color-violet-500 shadow-lg outline-2 outline-color-white dark:outline-color-[#11121E]">01</div>
                </div>

</div>